import "./CustomButton.less"
import { Component } from "react"

type CustomButtonProps = {
    onClick: ()=>void;
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
}

export default class CustomButton extends Component<CustomButtonProps>{
    render(){
        return <button className={`custom-button ${this.props.className || ""}`} style={this.props.style || {}} onClick={this.props.onClick}>
            {this.props.children}
        </button>
    }
}